// eslint-disable-next-line no-unused-vars
import { Typography } from '../types';

const familyPrimary = '"Source Sans Pro", "Helvetica Neue", Helvetica, Arial';

const weightNormal = '400';
const weightBold = '700';
const weightBlack = '900';

const sizeTitle = '28px';
const sizeH1 = '24px';
const sizeH2 = '20px';
const sizeBody = '16px';
const sizeSmall = '14px';

const lineHeightTitle = '35px';
const lineHeightH1 = '30px';
const lineHeightH2 = '25px';
const lineHeightBody = '20px';
const lineHeightSmall = '18px';

export const typography: Typography = {
  borderFocusWidth: '3px',
  size: {
    title: sizeTitle,
    h1: sizeH1,
    h2: sizeH2,
    body: sizeBody,
    small: sizeSmall,
  },

  fontFamily: {
    primary: familyPrimary,
  },

  fontWeight: {
    normal: weightNormal,
    bold: weightBold,
    black: weightBlack,
  },

  pageTitle: {
    size: sizeTitle,
    weight: weightBlack,
    altWeight: weightNormal,
    lineHeight: lineHeightTitle,
    mobileSize: sizeTitle,
    mobileLineHeight: lineHeightTitle,
  },

  sectionTitle: {
    size: sizeH1,
    weight: weightBold,
    altWeight: weightNormal,
    lineHeight: lineHeightH1,
    mobileSize: sizeH1,
    mobileLineHeight: lineHeightH1,
  },

  subSectionTitle: {
    size: sizeH2,
    weight: weightBold,
    subTitleWeight: weightNormal,
    lineHeight: lineHeightH2,
    mobileSize: sizeH2,
    mobileLineHeight: lineHeightH2,
  },

  body: {
    size: sizeBody,
    weight: weightNormal,
    lineHeight: lineHeightBody,
    style: 'normal',
  },

  bodyPlaceHolder: {
    size: sizeBody,
    lineHeight: lineHeightBody,
    style: 'italic',
  },

  hyperlink: {
    size: sizeBody,
    weight: weightBold,
    lineHeight: lineHeightBody,
  },

  label: {
    size: sizeBody,
    weight: weightBold,
    lineHeight: lineHeightBody,
  },

  metadata: {
    size: sizeSmall,
    weight: weightBold,
    lineHeight: lineHeightSmall,
    textTransform: 'uppercase',
  },

  timestamp: {
    size: sizeSmall,
    lineHeight: lineHeightSmall,
  },

  small: {
    size: sizeSmall,
    lineHeight: lineHeightSmall,
  },
};
